import request from '@/utils/request'

export function getUserMessageNotificationUptodateList(data) {
  return request({
    url:'/messageNotificationController/getUserMessageNotificationUptodateList',
    method:'post',
    data:data,
  })
}






export function getUserMessageNotificationAllList(data) {
  return request({
    url:'/messageNotificationController/getUserMessageNotificationAllList',
    method:'post',
    data:data,
  })
}


export function markMessageAsRead(data) {
  return request({
    url:'/messageNotificationController/markMessageAsRead',
    method:'post',
    data:data,
  })
}


export function getMessageCount(data) {
  return request({
    url:'/messageNotificationController/getMessageCount',
    method:'post',
    data:data,
  })
}




// WEBPACK FOOTER //
// ./src/api/messageNotification.js